/**
 * @param data {Data}
 */
function thenAppendUtmParametersToAllForms(data) {
	runProcessUrlAndSaveUTMCookies(data.jsCookie, data._);

	runAppendUtmCookieFieldsToAllForms(data.jsCookie);

	document.addEventListener('itbl.marketoSubmitted', () => {
		whenFormSubmits(data);
	});
}
